module.exports = __webpack_public_path__ + "img/chevron-right-small.c1cd5f06.svg";